import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Marcas } from '../_model/marcas';
import { MarcasService } from '../_services/marcas.service';

@Component({
    selector: 'app-joia',
    templateUrl: './joia.component.html',
    styleUrls: ['./joia.component.less'],
    standalone: false
})
export class JoiaComponent implements OnInit {

  constructor(private marca: MarcasService) { }

  marcasJoia: Marcas[] = [];
  marcasPrata: Marcas[] = [];
  apiUrl: string = environment.apiUrl;
  showAll: boolean = false;

  ngOnInit() {
    this.marca.listPathOrder('joia').subscribe((data: any) => {
      data.forEach(el => {
        this.marcasJoia.push(new Marcas(el));
      });
    });
    this.marca.listPathOrder('prata').subscribe((data: any) => {
      data.forEach(el => {
        this.marcasPrata.push(new Marcas(el));
      });
    });
  }

  toogle() {
    this.showAll = !this.showAll;
  }
  link(item: Marcas):string {
    return item.link == '' ? "/produtos?query=&marca="+item.id+"&type="+item.tipo : (item.link.includes("http") ? item.link : "https://"+item.link);
  }

}
